/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {GameAssets} from "../GameAssets";
import {TranslationConfig} from "../translations/TranslationConfig";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {PunkRocker} from "../PunkRocker";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";


export class PunkRockerIntroConfig implements GameIntroViewConfig {

    colors:GameIntroColors = {
        slideShowColors:{
            backgroundColor:0x000000,
            backgroundAlpha:0,
            bulletColor:0xffffff
        },
        stampColor:0xFFFFFF,
    };


    stampConfig:StampConfig = {
        xWays:true,
        xNudge:false,
        volatility:Volatility.HIGH
    };

    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];


    public static INTRO_BG = "resources/images/introBackground.jpg";
    private bgBlack:PIXI.Sprite;

    constructor() {
    }

    public init():Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add(PunkRockerIntroConfig.INTRO_BG,PunkRockerIntroConfig.INTRO_BG);
        imgLoader.add(GameAssets.IN_GAME_ARROW,GameAssets.IN_GAME_ARROW); //Needed elsewhere. It was in the intro spritesheet so loading it  here.

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();

        this.bgBlack = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.bgBlack.anchor.set(0.5, 0.5);
        this.bgBlack.tint = 0x000000;
        this.bgBlack.alpha = 1;
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture(PunkRockerIntroConfig.INTRO_BG));
        bgSprite.anchor.set(0.5, 0.5);
        bgSprite.scale.set(0.75,0.75);

        this.background.addChild(this.bgBlack);
        this.background.addChild(bgSprite);
        this.borderTop = new PIXI.Container();
        this.borderBottom = new PIXI.Container();
        this.logo = new PIXI.Container();

        const textStyle = new PIXI.TextStyle({
            fontFamily : OpenSans.FAMILY,
            fontStyle : FontStyle.NORMAL,
            fontWeight : FontWeight.BOLD,
            dropShadow: true,
            dropShadowAngle: 8,
            dropShadowBlur: 4,
            dropShadowDistance: 4,
            fill: "#FFFC00",
            fontSize: 30,
            lineJoin: "round",
            stroke: "#434343",
            strokeThickness: 4
        });

        const textObj = new PIXI.Text(Translation.translate(TranslationConfig.SPLASH_WIN_MORE) + " 15 000x " + Translation.translate(TranslationConfig.SPLASH_TIMES_BET),textStyle);
        textObj.anchor.set(0.5,0.5);
        textObj.position.set(0,175);
        const page = new SlideShowPage();
        page.addChild(textObj);

        if (PunkRocker.api.gameClientConfiguration.isSet) {
            if (!PunkRocker.api.gameClientConfiguration.showLowProbabilityGfx) {
                textObj.visible = false;
            }
        } else {
            PunkRocker.api.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (!PunkRocker.api.gameClientConfiguration.showLowProbabilityGfx) {
                    textObj.visible = false;
                }
            });
        }

        this.pages = [
            page
        ];
    }

    onResize():void {
        const bounds = NolimitApplication.screenBounds;
        this.bgBlack.width = bounds.width;
        this.bgBlack.height = bounds.height;
    }


}